import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
import numeroALetra from "../Components/numeroALetra";
import { formatQRTotal } from "../Components/RoundQRDecimals";

moment.locale("es");

const ticketComplementoPdf = (values) => {
  const empresa = values.respuestaComplemento.empresa;
  const dataSat = values.respuestaComplemento.dataSat;
  const dataExtra = values.respuestaComplemento.data;
  const logo = empresa.logo.base64Completa;

  let cancelado = {};
  if (values.estado === 0) {
    cancelado = { watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } };
  }

  if (dataSat.Version.toString() === '4.0') {
    // Genera dinámicamente las filas para la tabla de conceptos
    const filasConceptos = [];
    dataSat.Conceptos.forEach((concepto) => {
      // Primera fila - Descripción
      filasConceptos.push([
        {
          text: concepto.Descripcion + (concepto.Observaciones ? ("\n" + concepto.Observaciones) : ""),
          style: "tProductsBody",
          fontSize: 6,
          colSpan: 5,
          alignment: "left"
        },
        {}, {}, {}, {}
      ]);

      // Segunda fila - Datos del concepto
      filasConceptos.push([
        {
          text: concepto.ClaveProdServ,
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: concepto.Cantidad,
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: concepto.ClaveUnidad ? concepto.ClaveUnidad.slice(0, 3) : '',
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: dineroDisabledMask(concepto.ValorUnitario),
          style: "tProductsBody",
          fontSize: 6,
          alignment: "right"
        },
        {
          text: dineroDisabledMask(concepto.Importe),
          style: "tProductsBody",
          fontSize: 6,
          alignment: "right"
        }
      ]);
    });

    // Genera dinámicamente las filas para la tabla de pagos
    const filasPagos = [];
    dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].DoctoRelacionado.forEach((valuePago) => {
      let folio = '';
      if (valuePago.folioVenta) {
        folio = valuePago.folioVenta;
      }

      // Primera fila - UUID del documento
      filasPagos.push([
        {
          text: valuePago.IdDocumento,
          style: "tProductsBody",
          fontSize: 6,
          colSpan: 5,
          alignment: "left"
        },
        {}, {}, {}, {}
      ]);

      // Segunda fila - Datos del pago
      filasPagos.push([
        {
          text: folio,
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: valuePago.MonedaDR,
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: valuePago.NumParcialidad,
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: dineroDisabledMask(valuePago.ImpPagado),
          style: "tProductsBody",
          fontSize: 6,
          alignment: "right"
        },
        {
          text: dineroDisabledMask(valuePago.ImpSaldoInsoluto),
          style: "tProductsBody",
          fontSize: 6,
          alignment: "right"
        }
      ]);
    });

    const totalqr = formatQRTotal(dataSat.Total);
    let cadena8 = dataExtra.selloCFDI;
    cadena8 = cadena8.slice(-8);

    const linkqr = `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=${dataExtra.uuid}&re=${empresa.rfc}&rr=${dataSat.Receptor.Rfc}&tt=${totalqr}&fe=${cadena8}`;

    return {
      pageSize: { width: 206, height: "auto" },
      pageMargins: [10, 10, 10, 10],
      ...cancelado,
      content: [
        {
          image: logo,
          fit: [141.73, 56.692],
          alignment: "center",
        },
        {
          text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre + " " + empresa.apellidoPaterno + " " + empresa.apellidoMaterno),
          style: "header",
          margin: [0, 10, 0, 0],
          alignment: "center",
          fontSize: 12,
        },
        {
          text: empresa.rfc,
          style: "header",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: empresa.calle + " " + empresa.numeroCalle + " " + (empresa.numeroInterior ? empresa.numeroInterior : " "),
          style: "header",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: empresa.colonia.nombre + " " + empresa.colonia.cp + " " + empresa.municipio.nombre + " " + empresa.estado.abreviatura + " " + empresa.pais.abreviatura,
          style: "header",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: `Regimen Fiscal: (${empresa.regimenFiscal.c_RegimenFiscal}) ${empresa.regimenFiscal.descripcion}`,
          style: "header",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: "Tipo De Comprobante: (P) Pago",
          style: "header",
          alignment: "center",
          fontSize: 6,
        },

        { text: `Nº Complemento - ${dataSat.Serie} - ${dataSat.Folio}`, margin: [5, 3, 0, 3], style: "header", fontSize: 10, },

        {
          margin: [0, 2, 0, 0],
          table: {
            widths: ["100%"],
            body: [
              [
                { text: dataSat.Receptor.Nombre, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: dataSat.Receptor.Rfc, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: `(${dataSat.usoDeCFDI.c_UsoCFDI}) ${dataSat.usoDeCFDI.descripcion}`, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: `Fecha: ${moment(dataSat.Fecha).format('DD/MM/YYYY')}`, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: dataSat.LugarExpedicion, style: "tHeaderValue", fontSize: 6, },
              ],
            ],
          },
          layout: {
            defaultBorder: false,
            paddingTop: () => 0,
            paddingBottom: () => 0,
          },
        },

        {
          margin: [0, 2, 0, 0],
          table: {
            widths: ["20%", "16%", "16%", "24%", "24%"],
            headerRows: 2,
            body: [
              [
                {
                  text: "CONCEPTOS",
                  colSpan: 5,
                  style: "tTitleHeader",
                  alignment: "center",
                  fontSize: 12,
                  margin: [0, 3, 0, 0],
                },
                {}, {}, {}, {}
              ],
              [
                {
                  text: "CLAVE SAT",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "CANT.",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "UNIDAD",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "PRECIO",
                  style: "tProductsHeader",
                  alignment: "right",
                  fontSize: 7,
                },
                {
                  text: "IMPORTE",
                  style: "tProductsHeader",
                  alignment: "right",
                  fontSize: 7,
                },
              ],
              ...filasConceptos,
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i !== 0 && i !== 1 && i % 2 === 0) ? 1 : 0;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function () {
              return "#adaaaa";
            },
            paddingTop: function (i, node) {
              return 0;
            },
          },
        },

        {
          margin: [0, 2, 0, 0],
          table: {
            widths: ["20%", "20%", "20%", "20%", "20%"],
            headerRows: 2,
            body: [
              [
                {
                  text: "DOCUMENTOS PAGADOS",
                  colSpan: 5,
                  style: "tTitleHeader",
                  alignment: "center",
                  fontSize: 12,
                  margin: [0, 3, 0, 0],
                },
                {}, {}, {}, {}
              ],
              [
                {
                  text: "FOLIO",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "MONEDA",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "PARC.",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "PAGADO",
                  style: "tProductsHeader",
                  alignment: "right",
                  fontSize: 7,
                },
                {
                  text: "SALDO",
                  style: "tProductsHeader",
                  alignment: "right",
                  fontSize: 7,
                },
              ],
              ...filasPagos,
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i !== 0 && i !== 1 && i % 2 === 0) ? 1 : 0;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function () {
              return "#adaaaa";
            },
            paddingTop: function (i, node) {
              return 0;
            },
          },
        },

        {
          margin: [0, 2, 0, 0],
          table: {
            widths: ["100%"],
            headerRows: 1,
            body: [
              [
                {
                  text: "FORMA DE PAGO",
                  style: "tTitleHeader",
                  alignment: "center",
                  fontSize: 10,
                  margin: [0, 3, 0, 0],
                }
              ]
            ],
          },
          layout: {
            defaultBorder: false,
          },
        },

        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["100%"],
            body: [
              [
                { text: `Fecha: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].FechaPago}`, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: `Forma: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].FormaDePagoP}`, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: `Moneda: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].MonedaP}`, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: `Núm. Operación: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].NumOperacion || 'N/A'}`, style: "tHeaderValue", fontSize: 6, },
              ],
            ],
          },
          layout: {
            defaultBorder: false,
            paddingTop: () => 0,
            paddingBottom: () => 0,
          },
        },

        {
          margin: [5, 3, 0, 3],
          table: {
            widths: ["25%", "35%", "15%", "25%"],
            body: [
              [
                { text: "TOTAL PAGADO: ", style: "tTotals", colSpan: 2, fontSize: 8, },
                {},
                { text: dineroDisabledMask(dataSat.Complemento.Any[0]["Pago20:Pagos"].Totales.MontoTotalPagos), style: "tTotals", colSpan: 2, fontSize: 8, alignment: "right", },
                {},
              ],
              [
                {},
                {},
                {},
                {},
              ],
              [
                {
                  text: numeroALetra(dataSat.Complemento.Any[0]["Pago20:Pagos"].Totales.MontoTotalPagos, dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].MonedaP),
                  style: "tProductsBody",
                  colSpan: 4,
                  fontSize: 8,
                },
                {},
                {},
                {},
              ],
            ],
          },
          layout: "noBorders",
        },

        // Datos bancarios si existen
        ...(dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].CtaOrdenante || empresa.banco || empresa.cuentaBanco
          ? [
            {
              margin: [0, 5, 0, 0],
              table: {
                widths: ["100%"],
                headerRows: 1,
                body: [
                  [
                    {
                      text: "DATOS BANCARIOS",
                      style: "tTitleHeader",
                      alignment: "center",
                      fontSize: 10,
                      margin: [0, 3, 0, 0],
                    }
                  ]
                ],
              },
              layout: {
                defaultBorder: false,
              },
            },
            {
              margin: [0, 0, 0, 0],
              table: {
                widths: ["100%"],
                body: [
                  ...(dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].CtaOrdenante
                    ? [
                      [{ text: `Cta. Ordenante: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].CtaOrdenante}`, style: "tHeaderValue", fontSize: 6, }],
                      [{ text: `RFC Ordenante: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].RfcEmisorCtaOrd || 'N/A'}`, style: "tHeaderValue", fontSize: 6, }],
                    ]
                    : []),
                  ...(dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].NomBancoOrdExt
                    ? [
                      [{ text: `Banco Ordenante: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].NomBancoOrdExt}`, style: "tHeaderValue", fontSize: 6, }],
                    ]
                    : []),
                  ...(dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].CtaBeneficiario
                    ? [
                      [{ text: `Cta. Beneficiario: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].CtaBeneficiario}`, style: "tHeaderValue", fontSize: 6, }],
                      [{ text: `RFC Beneficiario: ${dataSat.Complemento.Any[0]["Pago20:Pagos"].Pago[0].RfcEmisorCtaBen || 'N/A'}`, style: "tHeaderValue", fontSize: 6, }],
                    ]
                    : []),
                  ...(empresa.banco
                    ? [
                      [{ text: `Banco: ${empresa.banco}`, style: "tHeaderValue", fontSize: 6, }],
                    ]
                    : []),
                  ...(empresa.cuentaBanco
                    ? [
                      [{ text: `Cuenta: ${empresa.cuentaBanco}`, style: "tHeaderValue", fontSize: 6, }],
                    ]
                    : []),
                  ...(empresa.cuentaClabe
                    ? [
                      [{ text: `Cuenta CLABE: ${empresa.cuentaClabe}`, style: "tHeaderValue", fontSize: 6, }],
                    ]
                    : []),
                  ...(empresa.swiftCode
                    ? [
                      [{ text: `Swift Code: ${empresa.swiftCode}`, style: "tHeaderValue", fontSize: 6, }],
                    ]
                    : []),
                  ...(empresa.abaCode
                    ? [
                      [{ text: `ABA Code: ${empresa.abaCode}`, style: "tHeaderValue", fontSize: 6, }],
                    ]
                    : []),
                ],
              },
              layout: {
                defaultBorder: false,
                paddingTop: () => 0,
                paddingBottom: () => 0,
              },
            },
          ]
          : []),

        // Observaciones si existen
        ...(values.imprimirObservaciones && values.observaciones
          ? [
            {
              margin: [0, 5, 0, 0],
              table: {
                widths: ["100%"],
                headerRows: 1,
                body: [
                  [
                    {
                      text: "OBSERVACIONES",
                      style: "tTitleHeader",
                      alignment: "center",
                      fontSize: 10,
                      margin: [0, 3, 0, 0],
                    }
                  ]
                ],
              },
              layout: {
                defaultBorder: false,
              },
            },
            {
              margin: [0, 0, 0, 0],
              table: {
                widths: ["100%"],
                body: [
                  [
                    { text: values.observaciones, style: "tHeaderValue", fontSize: 6, },
                  ],
                ],
              },
              layout: {
                defaultBorder: false,
                paddingTop: () => 0,
                paddingBottom: () => 0,
              },
            },
          ]
          : []),

        // Información fiscal
        {
          text: "---------------------- INFORMACIÓN FISCAL ---------------------",
          style: "text",
          alignment: "center",
          fontSize: 7,
          margin: [5, 0, 0, 0],
        },
        {
          text: "Folio Fiscal:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
          margin: [5, 0, 0, 0],
        },
        {
          text: dataExtra.uuid,
          style: "text",
          fontSize: 4,
          margin: [5, 0, 0, 0],
        },
        {
          text: "Sello digital CFDI:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
          margin: [5, 0, 0, 0],
        },
        {
          text: dataExtra.selloCFDI,
          style: "text",
          fontSize: 4,
          margin: [5, 0, 0, 0],
        },
        {
          text: "Numero de serie del Certificado de Sello digital:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
          margin: [5, 0, 0, 0],
        },
        {
          text: dataExtra.noCertificadoCFDI,
          style: "text",
          fontSize: 4,
          margin: [5, 0, 0, 0],
        },
        {
          text: "Numero de serie del Certificado de Sello digital del SAT:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
          margin: [5, 0, 0, 0],
        },
        {
          text: dataExtra.noCertificadoSAT,
          style: "text",
          fontSize: 4,
          margin: [5, 0, 0, 0],
        },
        {
          text: "Cadena Original del complemento de certificación Digital SAT:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
          margin: [5, 0, 0, 0],
        },
        {
          text: dataExtra.cadenaOriginalSAT,
          style: "text",
          fontSize: 4,
          margin: [5, 0, 0, 0],
        },
        {
          text: "Sello Digital del SAT:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
          margin: [5, 0, 0, 0],
        },
        {
          text: dataExtra.selloSAT,
          style: "text",
          fontSize: 4,
          margin: [5, 0, 0, 0],
        },
        {
          stack: [
            {
              qr: linkqr,
              fit: 115,
              alignment: "center",
              eccLevel: "Q",
              margin: [0, 5, 0, 5],
            },
          ]
        },
        {
          text: "Sello Digital del CFDI:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
          margin: [5, 0, 0, 0],
        },
        {
          text: dataExtra.selloCFDI,
          style: "text",
          fontSize: 4,
          margin: [5, 0, 0, 0],
        },
      ],
      styles: {
        header: {
          bold: true,
          fontSize: 15,
        },
        tTitleHeader: {
          bold: true,
          fillColor: "#cccccc",
        },
        tProductsHeader: {
          bold: true,
          fillColor: "#f5f5f5",
        },
        tProductsBody: {
          // Sin estilos específicos, usa el default
        },
        tHeaderValue: {
          // Sin estilos específicos, usa el default
        },
        tTotals: {
          bold: true,
        },
      },
      defaultStyle: {
        fontSize: 12,
      },
    };

  } else if (dataSat.Version.toString() === '3.3') {
    // Similar estructura para versión 3.3 con las diferencias necesarias
    const filasConceptos = [];
    dataSat.Conceptos.forEach((concepto) => {
      filasConceptos.push([
        {
          text: concepto.Descripcion + (concepto.Observaciones ? ("\n" + concepto.Observaciones) : ""),
          style: "tProductsBody",
          fontSize: 6,
          colSpan: 5,
          alignment: "left"
        },
        {}, {}, {}, {}
      ]);

      filasConceptos.push([
        {
          text: concepto.ClaveProdServ,
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: concepto.Cantidad,
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: concepto.ClaveUnidad ? concepto.ClaveUnidad.slice(0, 3) : '',
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: dineroDisabledMask(concepto.ValorUnitario),
          style: "tProductsBody",
          fontSize: 6,
          alignment: "right"
        },
        {
          text: dineroDisabledMask(concepto.Importe),
          style: "tProductsBody",
          fontSize: 6,
          alignment: "right"
        }
      ]);
    });

    // let totalPago = 0;
    const filasPagos = [];
    dataSat.Complemento[0].Any[0]["Pago10:Pagos"].Pago.forEach((valuePago) => {
    //   totalPago += Number(valuePago.Monto);

      filasPagos.push([
        {
          text: valuePago.DoctoRelacionado[0].IdDocumento,
          style: "tProductsBody",
          fontSize: 6,
          colSpan: 5,
          alignment: "left"
        },
        {}, {}, {}, {}
      ]);

      filasPagos.push([
        {
          text: valuePago.DoctoRelacionado[0].MonedaDR,
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: valuePago.DoctoRelacionado[0].MetodoDePagoDR,
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: valuePago.DoctoRelacionado[0].NumParcialidad,
          style: "tProductsBody",
          fontSize: 6,
          alignment: "center"
        },
        {
          text: dineroDisabledMask(valuePago.DoctoRelacionado[0].ImpPagado),
          style: "tProductsBody",
          fontSize: 6,
          alignment: "right"
        },
        {
          text: dineroDisabledMask(valuePago.DoctoRelacionado[0].ImpSaldoInsoluto),
          style: "tProductsBody",
          fontSize: 6,
          alignment: "right"
        }
      ]);
    });

    return {
      pageSize: { width: 206, height: "auto" },
      pageMargins: [10, 10, 10, 10],
      ...cancelado,
      content: [
        // Header similar a la versión 4.0
        {
          image: logo,
          fit: [141.73, 56.692],
          alignment: "center",
        },
        {
          text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre + " " + empresa.apellidoPaterno + " " + empresa.apellidoMaterno),
          style: "header",
          margin: [0, 10, 0, 0],
          alignment: "center",
          fontSize: 12,
        },
        // ... resto del contenido similar adaptado para versión 3.3
        // (siguiendo la misma estructura pero con los datos de la versión 3.3)
      ],
      styles: {
        header: { bold: true, fontSize: 15 },
        tTitleHeader: { bold: true, fillColor: "#cccccc" },
        tProductsHeader: { bold: true, fillColor: "#f5f5f5" },
        tProductsBody: {},
        tHeaderValue: {},
        tTotals: { bold: true },
      },
      defaultStyle: { fontSize: 12 },
    };
  }
};

export default ticketComplementoPdf;